export default {
  freeTimesLimitTitle: "Dosya boyutu ücretsiz sürümde 20MB'yi aşamaz.",
  fileSizeLimitTitle: 'Yükselt',
  total: 'Toplam',
  enterCode: 'Kodu girin',
  signUpToPurchaseBtn: 'Satın Almak için Kaydolun',
  goPurchseBtn: 'Satın Almaya Git',
  saveTips: "% {{num}}' ye Kadar Tasarruf Edin",
  discount: 'İndirim',
  montly: 'Aylık',
  yearly: 'Yıllık',
  weekly: 'Haftalık',
  week: 'Hafta',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYearly: '$3,75',
  billMonth: '$29,99 Aylık Faturalandırılır',
  billYear: '$179,99 Yıllık Faturalandırılır',
  AlreadySubscribe: 'Zaten abonesin?',
  vipTips1: 'Dosya boyutu sınırlamaları yok',
  vipTips2: 'İşlenen dosya sayısına sınırlama yok',
  vipTips3: 'Sınırsız olarak görüntü arka planlarını değiştirin',
  vipTips4: 'Tüm ücretsiz araçlara ve premium özelliklere erişim',
  purchaseTips: 'Otomatik olarak yenileyin ve istediğiniz zaman iptal edin.',
  tips: 'İpuçları:',
  promoCodeInvalidTips: 'Promosyon kodunuz geçersiz',
};
